import React from "react";
import TaskItem from "./TaskItem";

function TaskListCompact({
  tasks,
  loadingTasks,
  editingTaskId,
  editType,
  editNoteHtml,
  editDueDate,
  editDueTime,
  editResponsibleIds,
  setEditType,
  setEditNoteHtml,
  setEditDueDate,
  setEditDueTime,
  setEditResponsibleIds,
  labelMap,
  getUserNameById,
  userOptions,
  loadingUsers,
  startEditTask,
  saveEditTask,
  cancelEditTask,
  handleToggleTaskStatus,
  handleDeleteTask,
  onDeleteAttachment,
  onConfirmComplete,
}) {
  if (loadingTasks) return <p className="text-sm text-gray-500">Carregando…</p>;
  if (!tasks?.length)
    return (
      <p className="text-sm italic text-gray-400">Nenhuma tarefa ainda.</p>
    );

  return (
    <div className="space-y-2">
      {tasks.map((t) => {
        const isEditing = editingTaskId === t.id;
        const editingData = isEditing
          ? {
              editType,
              editNoteHtml,
              editDueDate,
              editDueTime,
              editResponsibleIds,
            }
          : null;
        return (
          <TaskItem
            key={t.id}
            t={t}
            isEditing={isEditing}
            isDone={t.status === "done"}
            labelMap={labelMap}
            getUserNameById={getUserNameById}
            editingData={editingData}
            setEditType={setEditType}
            setEditNoteHtml={setEditNoteHtml}
            setEditDueDate={setEditDueDate}
            setEditDueTime={setEditDueTime}
            setEditResponsibleIds={setEditResponsibleIds}
            userOptions={userOptions}
            loadingUsers={loadingUsers}
            startEditTask={startEditTask}
            saveEditTask={saveEditTask}
            cancelEditTask={cancelEditTask}
            handleToggleTaskStatus={handleToggleTaskStatus}
            handleDeleteTask={handleDeleteTask}
            onDeleteAttachment={onDeleteAttachment}
            onConfirmComplete={onConfirmComplete}
          />
        );
      })}
    </div>
  );
}

export default React.memo(TaskListCompact);
